module.exports = __webpack_public_path__ + "media/images/mailer/badge_3-c61ba84e90d10b050a72a64b2c38d545.png";